import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Breadcrumb, Text } from '../..';
import { ThemeProps } from '../../../types';

interface PageProps {
  /**
   * Button contents
   */
  children: ReactNode;
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * A boolean to control the display of a loading spinner
   */
  isLoading?: boolean;
  /**
   * A boolean to control the display of the page content
   */
  isReady: boolean;
  /**
   * The current pageNumber the user is on
   */
  pageNumber?: number;
  /**
   * The title of the page
   */
  title: number;
}

const Page = ({
  children,
  className,
  isLoading = false,
  isReady = false,
  pageNumber,
  title,
}: PageProps) => {
  if (isLoading || !isReady) {
    return <p>'...Loading'</p>;
  }

  //Hide the progress breadcrumb if the user has arrived from either of the main sites
  //If either domain changes this will break and need to be updated
  let shouldShowBreadcrumb = true;
  if (document.referrer === "https://www.azoomee.com/" || document.referrer === "https://www.davincikids.tv/")
  {
    shouldShowBreadcrumb = false;
  }

  return (
    <div className={className}>
      { shouldShowBreadcrumb ? pageNumber && <Breadcrumb pageNumber={pageNumber} /> : null }
      <Text className='page-title' element='h1' variant='h1' weight='bold'>
        {title}
      </Text>
      {children}
    </div>
  );
};

const StyledPage = styled((props: any) => <Page {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    img: {
      width: 86,
    },
    '.page-title': {
      marginBottom: 34,
      marginTop: 24,
    },
    [theme.mq.desktop]: {
      '.page-title': {
        marginBottom: 40,
      },
    },
  })}
`;

export default StyledPage;
